<template>
<div class="content">
    <div class="container-fluid">
    <div class="row">
        <div class="col-md-12">
        <view-leave>
        </view-leave> 
        </div>
    </div>  
    </div>
</div>
</template>
<script>
/* eslint-disable */
import viewLeave from './todo-view-leave'
export default {
    components: {
        viewLeave
    }
}
</script>
<style lang="scss">
</style>


// WEBPACK FOOTER //
// src/components/Dashboard/Views/bp-leave-management/base-view-leave.vue